import UserClass from "./UserClass";
import {Component} from "react";
import UserContext from "../utils/userContext";

class About extends Component {
    constructor(props){
        super(props);

        //console.log("Parent Constructor");
    }

    componentDidMount(){
        // console.log("Parent Component Did Mount");
    }

    render(){
        return (
            <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 text-gray-800">

                <div className="bg-white shadow-lg rounded-lg p-8 w-10/12 md:w-8/12 lg:w-6/12">

                <div className="mb-4 text-center"> {/* in class based component
                    we use the useContext i..e the global data like this*/}
                    loggedInUser : <UserContext.Consumer> 
                    {({loggedInUser})=>(<h1 className="text-2xl font-bold text-blue-600">{loggedInUser}</h1>)}
                    </UserContext.Consumer>
                </div>
                <h1 className="text-3xl font-bold mb-2 text-gray-800">About Class Component</h1>
                <h2 className="text-lg text-gray-600 mb-4">This is Swiggy PROTOTYPE MADE by Parshuram!!!</h2>
                <div className="border-t-2 border-gray-200 mt-4 pt-4">
                <UserClass />
                 </div>
                 </div>
            </div>
        );
    }




}

export default About;